import { TextInput } from "@mantine/core";
import { IconSearch } from "@tabler/icons";

function SearchInput({ search, handleSearchChange }) {
  return (
    <TextInput
      placeholder="Recherche..."
      mb="lg"
      icon={<IconSearch size={14} stroke={1.5} />}
      value={search}
      onChange={handleSearchChange}
      className=""
    />
  );
}

export default SearchInput;
